import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
    pageHeading: {
        id: "fastshift.migrations-management-page.page-heading",
        defaultMessage: "Migration planning",
        description: "Heading for the migrations management page"
    },
    pageHeadingSubtext: {
        id: "fastshift.migrations-management-page.page-heading-subtext",
        defaultMessage:
            "Monitor your migration progress and review upcoming tasks to make sure everything stays on track.",
        description:
            "Subtext for the migrations management page under the heading"
    },
    genericErrorDescription: {
        id: "fastshift.migrations-management-page.error-display.generic-error.description",
        defaultMessage: "We couldn’t retrieve the data.",
        description:
            "Description for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data"
    }
});
